import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  Component,
  ViewChild,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LayoutService } from 'app/layout/layout.service';
import { Parcel, ResearchLayoutKeys } from '../research.types';
import { Actions, Select, ofActionDispatched, ofActionSuccessful } from '@ngxs/store';
import { ResearchState } from '../state/state';
import { BehaviorSubject, Observable, noop, tap } from 'rxjs';
import { Research } from '../state/actions';

@Component({
  selector: 'research-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResearchListComponent extends OnDestroyMixin implements OnInit {
  isLoading = false;

  @Select(ResearchState.listParcels) parcels$: Observable<Parcel[]>;

  @ViewChild('parcelList') parcelList: ElementRef;

  parcelDataLoading = new BehaviorSubject(false);

  constructor(
    private readonly router: Router,
    private readonly layoutService: LayoutService,
    private readonly actions$: Actions,
  ) {
    super();
  }

  ngOnInit(): void {
    this.actions$
      .pipe(
        ofActionDispatched(Research.GetAndSelectParcel),
        untilComponentDestroyed(this),
        tap(() => this.parcelDataLoading.next(true)),
      )
      .subscribe(noop);

    this.actions$
      .pipe(
        ofActionSuccessful(Research.GetAndSelectParcel),
        untilComponentDestroyed(this),
        tap(() => this.parcelDataLoading.next(false)),
      )
      .subscribe(noop);
  }

  displayOwner(parcel): string {
    return parcel.tax_assessor_owner__tax_assessor_id?.map((owner) => owner.owner_name).join(',');
  }

  trackByFn(index: number, item: any): any {
    if (item) {
      return item.id || index;
    } else {
      return index;
    }
  }

  loadParcelDetail(tax_assessor_id): void {
    this.router.navigate(['research', tax_assessor_id]);
  }

  searchOwner(owner: string): void {
    this.layoutService.emitCommon(ResearchLayoutKeys.SEARCH_OWNER, { owner });
  }

  searchAddress(ownerMailingAddress: string): void {
    this.layoutService.emitCommon(ResearchLayoutKeys.SEARCH_MAILING_ADDRESS, { ownerMailingAddress });
  }

  viewAsTable(parcels: Parcel[]): void {
    this.layoutService.emitCommon(ResearchLayoutKeys.VIEW_AS_TABLE, parcels);
  }
}
